import React from 'react';
import { Card, CardContent, Typography, Grid2 as Grid } from '@mui/material';

const ListNoResults = () => {
  return (
    <Grid size={12}>
      <Card>
        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
          <Typography
            align={'center'}
            variant={'body1'}
          >
            No Results
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ListNoResults;
